var _defs, _text, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _polygon, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _text2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 394.36 427.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:8px;font-family:ProximaNova-Light, Proxima Nova;font-weight:300;}.cls-1,.cls-10,.cls-7{fill:#231f20;}.cls-2{letter-spacing:-0.04em;}.cls-3{letter-spacing:-0.06em;}.cls-4{letter-spacing:0em;}.cls-5{fill:#812990;}.cls-6{fill:#6b7b84;}.cls-8{fill:url(#linear-gradient);}.cls-23,.cls-9{fill:none;stroke-miterlimit:10;stroke-width:0.25px;}.cls-9{stroke:#ffcb05;}.cls-10{font-size:4.55px;font-family:ProximaNova-Bold, Proxima Nova;font-weight:700;}.cls-11{letter-spacing:-0.01em;}.cls-12{font-family:ProximaNova-Regular, Proxima Nova;font-weight:400;}.cls-13{letter-spacing:-0.02em;}.cls-14{letter-spacing:-0.03em;}.cls-15{letter-spacing:-0.02em;}.cls-16{letter-spacing:-0.01em;}.cls-17{letter-spacing:0em;}.cls-18{letter-spacing:-0.03em;}.cls-19{letter-spacing:-0.01em;}.cls-20{letter-spacing:-0.05em;}.cls-21{letter-spacing:-0.04em;}.cls-22{letter-spacing:-0.01em;}.cls-23{stroke:#6b7b84;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 214.87,
    y1: 389.53,
    x2: 300.77,
    y2: 389.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d60f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#812990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(310.77 425.32)"
  }, "Size: A4 (21cm x 2", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 61.86,
    y: 0
  }, "9"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 66.25,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 67.49,
    y: 0
  }, "7cm)"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.16,50.71l-.7.1a2.06,2.06,0,0,1-.34.07c-.27,0-.41-.33-.78-.41-.09,0,0,0-.14,0s0,0-.17-.09c0,.25-.06.18-.06.37a1.39,1.39,0,0,0,.15.63c.07.14.1.09.1.29,0,.38-.06.48.1.79a1.89,1.89,0,0,1,.28.57c.37,0,.31,0,.36.11.34,0,.12-.08.31-.11,0,0,.35.08.26-.36.26.07.14.21.31.19s.07-.13.09-.29-.07,0,.18-.16l-.06-.31c0-.37.09,0,.21,0l.15-1.1c0-.08.12,0-.1-.35C54.08,50.69,54.21,50.69,54.16,50.71Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M54.26,49.78c0,.14.08.08-.1.1l.21.46c.09,0,.06,0,.2,0,0-.32,0-.21-.1-.37S54.4,49.81,54.26,49.78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M51.66,49.36c-.06.21,0,0-.07.17s-.09.46.22.3C51.81,49.46,51.85,49.49,51.66,49.36Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.65,45.68a1.89,1.89,0,0,0-.63.1c-.39.1-.22.18-.1.36a2.37,2.37,0,0,0,.91-.13c.16,0,.18,0,.08-.18h-.26Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M58.18,43.13a1.21,1.21,0,0,0,0-.18l-.59-.22c-.42-.16-.85-.31-1.26-.48s-.85-.35-1.32-.58-1-.51-1.54-.84a3.47,3.47,0,0,1-1.26-1.43,4.69,4.69,0,0,1-.28-.72h-.1a2.66,2.66,0,0,0-.57.07l-.54.14a6.65,6.65,0,0,1-1.45.27H49l-.55,0-.42,0c-.3,0-.59-.1-.87-.16l-.3-.07-.24.28a.57.57,0,0,1,.16.15,1,1,0,0,1,.22,1,1.58,1.58,0,0,1-1.36,1l-.49,0h-.09a1.69,1.69,0,0,1-1.34-.88,1.19,1.19,0,0,1,.1-1.3l0,0a3.53,3.53,0,0,1,.21-.32,3.07,3.07,0,0,0,.25-.38l.13-.28A1.79,1.79,0,0,1,43,37,3.87,3.87,0,0,1,42.74,36l-.15,0-.24.06a2.75,2.75,0,0,1-.2.23,1.34,1.34,0,0,1-.93.43,1.13,1.13,0,0,1-.36-.06H40.8a1.18,1.18,0,0,1-.69-.22.77.77,0,0,1-.39-.27.89.89,0,0,1-.18-.77,3.22,3.22,0,0,1,.6-1.29.43.43,0,0,1,.07-.1,1.23,1.23,0,0,1,.36-.74c.16-.16.32-.29.47-.42l.13-.11c.07-.06.16-.14.26-.21a1.56,1.56,0,0,1,.25-.69,2.85,2.85,0,0,1,.86-.83,4.86,4.86,0,0,1,.53-.31l.26-.15.24-.14.14-.09a.75.75,0,0,1,.41-.12.73.73,0,0,1,.33.08.81.81,0,0,1,.46.93s-.2.69-.27.91a2.08,2.08,0,0,1-.38.72c.17.11.37.24.56.39a3.6,3.6,0,0,1,.45.41h.33l.12,0a2.68,2.68,0,0,0,.82-.37l.12-.07a6.94,6.94,0,0,1,1.62-.77A10.91,10.91,0,0,1,51.16,32h.37c.54,0,1.07,0,1.57,0a8.75,8.75,0,0,1,1.19.16,7.05,7.05,0,0,1,2.88,1.25.56.56,0,0,0-.29-.4c-.15-.07-.07,0-.18-.09a0,0,0,0,1,0,0l-.12-.09c-.18-.12-.15,0-.22-.26l-.07,0,0,0c-.11,0-.08-.21-.18-.34s0,.1-.23,0,0,0-.08-.06a.25.25,0,0,0-.11,0l-.09,0c-.43-.18-.35-.25-.35-.68-.37-.1-.15-.38-.12-.62s-.19-.43-.09-.84c-.52,0-.31-.51-.46-1.06l0-.5c0-.11,0,.05.06-.15l-.14-.06c-.48-.29-.39-.52-.53-.61l-.36.11c-.11.08,0,.05-.16.09-.35-.32-.18-1-.3-1.42,0-.18-.08-.43-.33-.49a.75.75,0,0,1,.16-.31c-.13-.06-.19-.05-.31-.11a1.51,1.51,0,0,0-.16-.83c-.1-.17,0-.18-.26-.21-.06.25,0,.1-.26.21a1.48,1.48,0,0,1-.19.8s0,0,0,0l0,.06a1.06,1.06,0,0,0-.22.51h.15c0,.24,0,.1-.11.25s-.06,0,0,.25-.18.29-.16.58.08.13.08.32-.06.15-.05.29c0,.39.16.29,0,.67s-.11.76-.35,1.15-.2.46-.27.56a.74.74,0,0,1-.58.23,2.16,2.16,0,0,1-.53-.26c-.1-.05-.18-.08-.22-.18s0-.07-.07-.15c-.12-.26-.46-.24-.71-.33s-.33-.44-.93-.68l-.31-.1-.25-.17-.2-.22c-.06-.05-.17-.11-.24-.17L46.43,28c-.21-.11-.18,0-.19-.29.12,0,.25-.25.35-.39a.47.47,0,0,0,.06-.09l0-.11s0,0,0,0l.11-.25c-.22-.09,0,0-.21-.06.08-.12.06,0,.11-.2.26-.13.2-.06.36,0,.31-.46.13-.17.2-.44s.21-.27.32-.44l-.19-.12c-.22-.12-.17.08-.17-.3a1,1,0,0,0-.42.31c-.06-.07-.06.11-.06-.15a.78.78,0,0,1-.26.1c.16-.2.09,0,.16-.21a1.49,1.49,0,0,0-.68.26c-.13-.09-.2-.08-.26-.26-.26,0-.07,0-.3.11a1.19,1.19,0,0,0-.42-.21v-.1c-.28,0-.46.17-.7-.09,0,0-.11-.19-.14-.22-.19,0-.1,0-.26.15a.39.39,0,0,0-.23-.29c-.08-.06,0,0-.1,0l-.29,0s.07,0-.16.05v.16c.2,0,0,0,.15.06a.05.05,0,0,0,0,0,0,0,0,0,0,0,0c.15.07.16,0,.41,0a1.21,1.21,0,0,1,.1.47l-.38.13,0,0L43,25.6c-.2,0-.13-.05-.21-.2l-.13.07-.14.08c-.15.11.08,0-.17.13a.47.47,0,0,1-.24,0c0,.13,0,.13-.11.29s0,.16-.26.18c0,.37,0,.16.11.41l-.17.06c-.26.06-.13.06-.23.32s-.22.08-.32.56c.16.11.2.11.23.22a.42.42,0,0,1,0,.19c-.5,0-.28,0-.46,0a2.13,2.13,0,0,0-.58-.09c0,.38,0,.12-.11.22l0,0-.08.12c0-.36.08-.11.1-.41-.44-.13-.42-.59-.87-.67s0-.1-.38-.11c-.09.19,0,.23-.21.36.06-.25,0-.08,0-.16s-.11.06-.26.16c0-.24-.06-.2-.26-.1,0,.15,0,.1.16.15a.67.67,0,0,0-.11.31L38,27.47c-.13.27,0,.18-.19.32l-.07,0-.16.11c.08.28.14,0,.06.26-.18,0-.19.07-.32.23,0,0,0,0,0,0l0,.05-.08.07c-.08.07-.17.1-.19.26a.45.45,0,0,0,.13.3c-.12.14-.1.09-.11.31l-.23-.08c-.24-.05-.11.13-.18-.07h-.26c0,.35-.13.27-.06.42s.19.13.32.3c-.13.06,0,0-.21,0,0,.28.06.09,0,.37-.16-.12-.08-.09-.26-.42s-.19-.12-.16-.47c-.21.07-.2.17-.31.32l-.25.26a.91.91,0,0,0-.2.42c0,.15.09.23.09.51,0,0,0,0,0,0l.14,0c0,.11,0,.06-.08.13a.21.21,0,0,1,0,.06c-.08.08,0,0-.09.07l-.08.07,0,0-.06,0c-.13.11-.1.12-.16.26l0,.07c-.31.82-.5.82-1.43,1.17-.17.06,0,0-.19.06s-.14-.13-.35,0,0,.12-.21.26-.29-.09-.78.41a.44.44,0,0,1-.32.13c-.27,0-.07-.15-.42.07,0-.27.06-.09-.1-.16,0,.17,0,.14-.17.25-.32.23-.06-.07-.52.43l-.05.05-.16.2s0,0,0,.06c-.24.27-.77.16-.77,1h-.15a4,4,0,0,1-.05-.57,1.19,1.19,0,0,0-.37.93c.17.06,0-.09.14.13a.75.75,0,0,1,0,.64.59.59,0,0,0-.1.28v.37c0,.12,0,.09.17.23s0,.19.26.46l0,0a2,2,0,0,1,.13.18c.21.27.3.13.3.75h-.11a.85.85,0,0,0-.58-.68c0,.48.13.16.17.52-.13-.07-.06-.06-.21-.1,0,.27,0,.09-.11.16.34.5.87.69,1,1.34.05.29.36.44.46.68s0,0,.09.17.1.09.16.15a.76.76,0,0,1,.17.45c.18,1.1.84,1.33.91,2v.38c0,.23,0,.19.09.42s0,.31-.08.48a1.46,1.46,0,0,1-.31,0c0,.37,0,.71.32.71s.59.53,1.31.41a3,3,0,0,0,.8-.1.86.86,0,0,0,.3-.33l0,0,.07-.09,0-.05.15-.09c.12,0,.32,0,.37-.18v-.1c.07-.29.49-.28.75-.38l.6-.08h.12c.19,0,0,0,.14,0l.08,0,0,0c.18.08-.14,0,.19.06.05-.11.11-.17.44-.16s.6.16.77-.54a.45.45,0,0,1,.1-.27c.13-.15.21-.09.42-.21.83-.48.5-.56,1.44-.58a2.59,2.59,0,0,0,1-.3c.61-.25.55-.42,1.5-.42a2.3,2.3,0,0,0,.6-.09c.22,0,.68.33.86.45.3-.08.14-.22.5,0a1.93,1.93,0,0,0,.64.15c.07.16,0,0,0,.26.17,0,.17-.07.31,0,0,.11-.1.07-.13.19l.11.29c.13.12.23,0,.36.16s.08.23.27.46a.8.8,0,0,1,.17.51s0,0,0,0h-.05l-.13.14c.31,0,.23.23.51.29l.11,0s0,0,.1,0l0-.2c0-.16,0-.21.31-.57s.55-.24.7-.51a1.18,1.18,0,0,1,.23-.39c.13-.13,0,.06.11-.14,0,0,0,0,0,0s0,0,.05.06a.62.62,0,0,1,.08.12c-.15,0-.13,0-.2.1.1.24.11.21,0,.35a1.22,1.22,0,0,0-.26.82c0,.31-.07.24-.36.24-.05.19-.08.14-.11.36a1.29,1.29,0,0,0,.37-.1c.22-.06.25.12.37-.16l.2-.62.1.16s0,0,0,0l0,.06v0c.29.58-.19.6-.22.94a1.5,1.5,0,0,0,.52-.1l0,0s0,0,0,0c.32.27.67.63.52,1.1v.29a.87.87,0,0,0,.22.33l.21.35c.17.18.4.1.59.31l.14.16c.15,0,.15-.11.32-.07l.11,0,.05,0c.13,0,.06,0,.19.06s.53.29.58.41c.29,0,.85-.74,1-.21.26,0,.27-.18.48-.2l0,.07c-.07.15,0-.1-.07.19l.25.22.07.07.16.06c.06,0,.07.13.1.22a.27.27,0,0,0,.15-.37c.61,0,.79-.61,1.44-.59.42,0,.75.15,1-.09l.11-.15c.08-.18,0-.23,0-.39l.28-.75a1,1,0,0,1,.55-.67c.15-.13,0,0,.05-.14v0l0-.14a1.13,1.13,0,0,1,.28-.49c.31-.25.18-.43.64-.92l.3-.17,0,0,.11-.07C58.32,43.85,58.25,43.49,58.18,43.13Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35.28,31Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M44.87,34.36a5,5,0,0,0-.53-.51,7.39,7.39,0,0,0-.8-.53,1.74,1.74,0,0,0-.4-.15.79.79,0,0,0-.26,0,1.71,1.71,0,0,1,.44-.49,1.52,1.52,0,0,0,.57-.77c.09-.3.17-.6.26-.9l0,0-.4.25-.76.43a2.12,2.12,0,0,0-.62.61.89.89,0,0,0-.13.63c0,.16-.07.16-.07.16a1.1,1.1,0,0,0-.46.27c-.19.16-.38.32-.55.49a.42.42,0,0,0-.14.28.89.89,0,0,1-.22.47,2.45,2.45,0,0,0-.46,1c0,.13,0,.18.17.15a.36.36,0,0,0,.41.16s0,0,.06,0c.27.13.4.11.65-.13a1.06,1.06,0,0,0,.17-.2c.13-.19.33-.2.52-.26a1.56,1.56,0,0,0,.64-.25s.15-.12.21,0a2.56,2.56,0,0,1,.26.34,2,2,0,0,1,.12.49,3.08,3.08,0,0,0,.18,1,1,1,0,0,0,1.19.63,2,2,0,0,1,1,0l.2.09-.39,0a.13.13,0,0,0-.13.09c-.18.43-.35.86-.56,1.27s-.34.51-.5.76-.23.34-.12.52a.91.91,0,0,0,.72.51l.53,0a.79.79,0,0,0,.61-.45.28.28,0,0,0-.08-.29c-.05.13-.15.15-.26.17a.45.45,0,0,0-.18.07c0-.12.11-.11.21-.14l0-.23-.06,0c-.11.15-.17.17-.35.11l-.14,0c-.15-.05-.18,0-.19.12a.34.34,0,0,0,0,.11.3.3,0,0,1,0-.4,8.32,8.32,0,0,1,.6-.71,7.84,7.84,0,0,0,1.23-1.63,1,1,0,0,0,.11-.3.59.59,0,0,0-.28-.61,5.55,5.55,0,0,0-.74-.44.51.51,0,0,1-.32-.61l.07.2c0,.18.23.24.37.32s.49.23.72.36a.72.72,0,0,1,.23,1.15l-.38.61c0,.07,0,.12.07.14.42.08.83.19,1.25.24a5.79,5.79,0,0,0,1,0A10.71,10.71,0,0,0,51,38a2.67,2.67,0,0,1,1.09-.06l.08,0-.06-.58c0-.16,0-.32,0-.49a4,4,0,0,0-.39-1.58,1.75,1.75,0,0,0-.16-.25.9.9,0,0,1,.35.32,1.87,1.87,0,0,1,.3.78c.09.48.15,1,.23,1.44a5.17,5.17,0,0,0,.43,1.5,2.73,2.73,0,0,0,1,1.12c.47.29,1,.55,1.47.8s.84.38,1.27.56l1.6.61.78.28a.47.47,0,0,1,.31.29l-.43-.21v0c0,.15.09.29.12.45.08.4.15.8.22,1.21s.11.63.15,1a4.53,4.53,0,0,1,0,.52,1.12,1.12,0,0,0,.25.73c0,.06.11.1.16.15a5.72,5.72,0,0,1,.91,1.12A1,1,0,0,0,61,48h.26s0-.06,0-.08a.3.3,0,0,1,0-.39,1,1,0,0,0,.12-.29c0-.17-.08-.29-.17-.41a1.47,1.47,0,0,0-.1-.13l-.21.28,0,0a.49.49,0,0,0,.07-.55.89.89,0,0,0-.35-.48.82.82,0,0,1-.4-.7c-.06-.36-.09-.72-.13-1.09a4.6,4.6,0,0,1-.05-.64c0-.31.07-.61.09-.92a.67.67,0,0,0-.19-.5A4,4,0,0,0,59,41.4c-.54-.37-1.08-.74-1.59-1.14a7.52,7.52,0,0,1-1.74-2,2.33,2.33,0,0,1-.29-.89,1.59,1.59,0,0,1,.09-.75,3.21,3.21,0,0,0,.18,1.3c.28-.07.53-.18.58-.48a2.12,2.12,0,0,0,0-.56c0-.17.06-.27.23-.23a.87.87,0,0,1,.54.41c.43.63.83,1.28,1.25,1.92.25.4.5.79.76,1.18s.71,1,1.08,1.53a9.45,9.45,0,0,0,.66.76c.2.22.42.43.64.64a7.69,7.69,0,0,0,1.4,1.06,8,8,0,0,0,2,.87,13,13,0,0,0,1.48.32,7.5,7.5,0,0,0,1.25.08,9.91,9.91,0,0,0,1.32-.16,7.24,7.24,0,0,0,2-.68,9.68,9.68,0,0,0,.88-.52s.05,0,.05-.06l0-.2c-.06,0-.12,0-.17,0a3.71,3.71,0,0,0-.46.19,9,9,0,0,1-1.67.6,7.93,7.93,0,0,1-1.16.23,11.1,11.1,0,0,1-1.29,0,5.32,5.32,0,0,1-2.21-.63,7,7,0,0,1-1.49-1l-.49-.47a10.89,10.89,0,0,1-1.18-1.44,19.25,19.25,0,0,1-1.24-2l-.83-1.53a14.16,14.16,0,0,0-1.36-2.12,8.83,8.83,0,0,0-1.06-1.14,6.21,6.21,0,0,0-3-1.43,7.94,7.94,0,0,0-1.09-.15c-.62,0-1.25-.06-1.87,0a10.57,10.57,0,0,0-2.68.38,7,7,0,0,0-1.56.76,3.67,3.67,0,0,1-1,.47,1.43,1.43,0,0,1-.29,0,4.22,4.22,0,0,0-.62,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M113.12,26.14h-.42v1.19h-.24V26.14H112v-.25h1.09Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M114.66,25.89v1.44h-.25v-1l-.47.73-.47-.73v1h-.25V25.89h.27l.45.7.45-.7Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M75.4,29.61v.46a3.37,3.37,0,0,0-.82-.44,3.12,3.12,0,0,0-1-.17,3.25,3.25,0,0,0-1.23.23,2.92,2.92,0,0,0-1,.66,2.74,2.74,0,0,0-.64,1,3.17,3.17,0,0,0,0,2.37,2.84,2.84,0,0,0,.64,1,2.76,2.76,0,0,0,1,.65,3.07,3.07,0,0,0,1.23.24h.12a3.41,3.41,0,0,0,1.24-.23V33.66h0a1.75,1.75,0,0,1-.57.37,1.89,1.89,0,0,1-.67.12l-.28,0h0A2.22,2.22,0,0,1,73,34a1.56,1.56,0,0,1-.57-.37,1.54,1.54,0,0,1-.51-1.16,1.58,1.58,0,0,1,.51-1.18,1.89,1.89,0,0,1,1.24-.48,1.75,1.75,0,0,1,1.24.48,1.58,1.58,0,0,1,.51,1.18v3h1.45V29.61Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69.23,35.53,66,32.42v3.11H64.55v-8.2H66v3.1l3.22-3.09h2.06L67,31.42l4.25,4.11Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M80.64,29.46a2.74,2.74,0,0,1,1.08.21,2.46,2.46,0,0,1,.83.59,2.58,2.58,0,0,1,.53.87,2.85,2.85,0,0,1,.19,1.06v3.34H81.81V32.19a1.24,1.24,0,0,0-.42-1,1.41,1.41,0,0,0-1-.39,1.4,1.4,0,0,0-1,.39,1.26,1.26,0,0,0-.42,1v3.34H77.52V29.62H79v.44a3.22,3.22,0,0,1,.74-.44A2.52,2.52,0,0,1,80.64,29.46Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100.37,29.62a2.52,2.52,0,0,1,1-.17v1.38a1.74,1.74,0,0,0-1.24.48,1.61,1.61,0,0,0-.51,1.18v3H98.14V29.61H99.6v.45A2.91,2.91,0,0,1,100.37,29.62Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M104.64,29.46a3.43,3.43,0,0,1,1.25.23,3.2,3.2,0,0,1,1,.66,3,3,0,0,1,.69,1,3,3,0,0,1,0,2.37,3.13,3.13,0,0,1-.69,1,3,3,0,0,1-1,.65,3.24,3.24,0,0,1-1.25.24,3.27,3.27,0,0,1-1.25-.24,3,3,0,0,1-1-.65,3,3,0,0,1-.68-1,2.93,2.93,0,0,1,0-2.37,2.85,2.85,0,0,1,.68-1,3.2,3.2,0,0,1,1-.66A3.47,3.47,0,0,1,104.64,29.46Zm0,1.38a1.75,1.75,0,0,0-1.24.48,1.58,1.58,0,0,0-.51,1.18,1.54,1.54,0,0,0,.51,1.16A1.56,1.56,0,0,0,104,34a1.89,1.89,0,0,0,.67.12,1.85,1.85,0,0,0,.67-.12,1.75,1.75,0,0,0,.57-.37,1.54,1.54,0,0,0,.51-1.16,1.58,1.58,0,0,0-.51-1.18A1.81,1.81,0,0,0,104.64,30.84Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M111.45,29.46a3.43,3.43,0,0,1,1.25.23,3.2,3.2,0,0,1,1,.66,3,3,0,0,1,.69,1,2.93,2.93,0,0,1,0,2.37,3.13,3.13,0,0,1-.69,1,3,3,0,0,1-1,.65,3.24,3.24,0,0,1-1.25.24,3.27,3.27,0,0,1-1.25-.24,3.22,3.22,0,0,1-1-.65,3,3,0,0,1-.68-1,2.93,2.93,0,0,1,0-2.37,2.85,2.85,0,0,1,.68-1,3.19,3.19,0,0,1,2.27-.89Zm0,1.38a1.73,1.73,0,0,0-1.23.48,1.58,1.58,0,0,0-.51,1.18,1.54,1.54,0,0,0,.51,1.16,1.61,1.61,0,0,0,.56.37,1.89,1.89,0,0,0,.67.12,1.85,1.85,0,0,0,.67-.12,1.75,1.75,0,0,0,.57-.37,1.54,1.54,0,0,0,.51-1.16,1.58,1.58,0,0,0-.51-1.18A1.81,1.81,0,0,0,111.45,30.84Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M95.88,29.61v.46A3,3,0,0,0,94,29.46a3.32,3.32,0,0,0-1.23.23,3,3,0,0,0-1,.66,2.91,2.91,0,0,0-.65,1,3.17,3.17,0,0,0,0,2.37,3,3,0,0,0,.65,1,2.81,2.81,0,0,0,1,.65,3.14,3.14,0,0,0,1.23.24h.13a3.41,3.41,0,0,0,1.24-.23V33.66h0a1.75,1.75,0,0,1-.57.37,1.84,1.84,0,0,1-.66.12l-.29,0h0a2.79,2.79,0,0,1-.39-.1,1.61,1.61,0,0,1-.56-.37,1.54,1.54,0,0,1-.51-1.16,1.58,1.58,0,0,1,.51-1.18,1.71,1.71,0,0,1,.56-.35,1.75,1.75,0,0,1,.68-.13,1.73,1.73,0,0,1,1.23.48,1.58,1.58,0,0,1,.51,1.18v3h1.46V29.61Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88.83,29.61h0v.45a3.37,3.37,0,0,0-.82-.44,2.83,2.83,0,0,0-.52-.13,3.22,3.22,0,0,0-.63-.05,3.18,3.18,0,0,0-1.21.23,2.91,2.91,0,0,0-1.56,1.62,3.35,3.35,0,0,0-.21,1.19h0a3,3,0,0,0,.23,1.18,2.84,2.84,0,0,0,.64,1,2.76,2.76,0,0,0,1,.65,3.07,3.07,0,0,0,1.23.24h.21a3.36,3.36,0,0,0,1.15-.23V33.66h0a1.75,1.75,0,0,1-.57.37,1.89,1.89,0,0,1-.67.12l-.28,0h0a2.22,2.22,0,0,1-.39-.1,1.71,1.71,0,0,1-1.08-1.54,1.54,1.54,0,0,1,.12-.61l0-.05a2,2,0,0,1,.37-.51,1.89,1.89,0,0,1,1.24-.48,1.75,1.75,0,0,1,1.24.48,2,2,0,0,1,.37.51l0,.05a1.59,1.59,0,0,1,.12.62v2.3A1.55,1.55,0,0,1,88.32,36a1.7,1.7,0,0,1-1.24.49,1.6,1.6,0,0,1-.87-.23l-1.06,1a3,3,0,0,0,.9.46,3.13,3.13,0,0,0,1,.17,3.1,3.1,0,0,0,1.25-.25,3.36,3.36,0,0,0,1-.65A3,3,0,0,0,90,36a2.78,2.78,0,0,0,.25-1.18V29.62H88.83Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M66.24,40.54v.39H64.55V38.72h1.62v.39H65v.56h1v.38H65v.49Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M69,38.54V40.9H68.6v-.1a1,1,0,0,1-.5.13.88.88,0,0,1,0-1.76,1.06,1.06,0,0,1,.5.13v-.76Zm-.43,1.85V39.7a.73.73,0,0,0-.42-.14.49.49,0,0,0-.51.49.48.48,0,0,0,.51.48A.66.66,0,0,0,68.6,40.39Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M71.81,39.2v1.7h-.44v-.11a.76.76,0,0,1-.46.14c-.5,0-.72-.23-.72-.78V39.2h.43v.95c0,.26.13.39.37.39a.54.54,0,0,0,.38-.14V39.2Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M74.49,40.59a.83.83,0,0,1-.66.34.88.88,0,1,1,0-1.76.81.81,0,0,1,.66.34l-.28.26a.44.44,0,0,0-.38-.21.49.49,0,1,0,0,1,.46.46,0,0,0,.38-.21Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M77.27,39.2v1.7h-.43v-.12a.92.92,0,0,1-.5.15.88.88,0,0,1,0-1.76,1.07,1.07,0,0,1,.5.14V39.2Zm-.43.51a.67.67,0,0,0-.42-.15.49.49,0,0,0-.51.49.5.5,0,0,0,.51.49.67.67,0,0,0,.42-.15Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M79,39.56v.6c0,.31,0,.39.27.39h.2v.32a.93.93,0,0,1-.4.07.49.49,0,0,1-.51-.54v-.83H78.3V39.2h.24v-.66H79v.66h.47v.36Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M80.49,38.79a.25.25,0,1,1,.5,0,.25.25,0,1,1-.5,0Zm0,.44H81v1.7h-.44Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M83.92,40.05a.93.93,0,1,1-.93-.88A.91.91,0,0,1,83.92,40.05Zm-.43,0a.5.5,0,1,0-.5.49A.49.49,0,0,0,83.49,40.05Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86.62,40v1h-.43V40c0-.26-.13-.39-.37-.39a.55.55,0,0,0-.37.13v1.21H85v-1.7h.44v.11a.75.75,0,0,1,.45-.14C86.4,39.2,86.62,39.43,86.62,40Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90,39.11v.78h1v.39H90v.65H89.6V38.72h1.66v.39Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.07,40.05a.93.93,0,1,1-.93-.88A.91.91,0,0,1,94.07,40.05Zm-.43,0a.49.49,0,0,0-.5-.49.49.49,0,1,0,0,1A.49.49,0,0,0,93.64,40.05Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.77,39.2v1.7h-.44v-.11a.78.78,0,0,1-.46.14c-.5,0-.73-.23-.73-.78V39.2h.44v.95c0,.26.13.39.37.39a.56.56,0,0,0,.38-.14V39.2Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.56,40v1h-.44V40c0-.26-.13-.39-.37-.39a.55.55,0,0,0-.37.13v1.21h-.44v-1.7h.44v.11a.75.75,0,0,1,.45-.14C99.33,39.2,99.56,39.43,99.56,40Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102.43,38.54V40.9H102v-.1a1,1,0,0,1-.49.13.88.88,0,0,1,0-1.76,1,1,0,0,1,.49.13v-.76ZM102,40.39V39.7a.68.68,0,0,0-.42-.14.48.48,0,0,0-.5.49.47.47,0,0,0,.5.48A.63.63,0,0,0,102,40.39Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105.3,39.2v1.7h-.43v-.12a.92.92,0,0,1-.5.15.88.88,0,0,1,0-1.76,1,1,0,0,1,.5.14V39.2Zm-.43.51a.67.67,0,0,0-.42-.15.48.48,0,0,0-.5.49.49.49,0,0,0,.5.49.65.65,0,0,0,.42-.15Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M107,39.56v.6c0,.31,0,.39.27.39h.2v.32a.93.93,0,0,1-.4.07.49.49,0,0,1-.51-.54v-.83h-.24V39.2h.24v-.66H107v.66h.47v.36Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.52,38.79a.25.25,0,1,1,.5,0,.25.25,0,1,1-.5,0Zm0,.44H109v1.7h-.43Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112,40.05a.93.93,0,1,1-.93-.88A.91.91,0,0,1,112,40.05Zm-.43,0a.5.5,0,1,0-.5.49A.49.49,0,0,0,111.52,40.05Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.66,40v1h-.44V40c0-.26-.13-.39-.37-.39a.55.55,0,0,0-.37.13v1.21H113v-1.7h.44v.11a.75.75,0,0,1,.45-.14C114.43,39.2,114.66,39.43,114.66,40Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M74.82,44.8v.39h-1.7V43h1.63v.39H73.56v.56h1v.38h-1v.49Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.83,42.83v2.36H76.4v-.1a1,1,0,0,1-.5.13.88.88,0,0,1,0-1.76,1.06,1.06,0,0,1,.5.13v-.76Zm-.43,1.85V44a.67.67,0,0,0-.42-.15.49.49,0,0,0-.51.49.48.48,0,0,0,.51.49A.67.67,0,0,0,76.4,44.68Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.84,43.49v1.7H78.4v-.11a.81.81,0,0,1-.46.14c-.5,0-.73-.23-.73-.79v-.94h.43v.94c0,.27.13.4.38.4a.56.56,0,0,0,.38-.14v-1.2Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M80.74,44.88a.83.83,0,0,1-.66.34.88.88,0,1,1,0-1.76.81.81,0,0,1,.66.34l-.28.26a.44.44,0,0,0-.38-.21.49.49,0,1,0,0,1,.46.46,0,0,0,.38-.21Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M82.75,43.49v1.7h-.44v-.12a.92.92,0,0,1-.5.15.88.88,0,0,1,0-1.76.94.94,0,0,1,.5.14v-.11Zm-.44.51a.63.63,0,0,0-.42-.15.48.48,0,0,0-.5.49.49.49,0,0,0,.5.49.63.63,0,0,0,.42-.15Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M83.68,43.85v.6c0,.31,0,.4.27.4l.2,0v.33a1.32,1.32,0,0,1-.4.06.49.49,0,0,1-.51-.54v-.83H83v-.36h.24v-.66h.44v.66h.47v.36Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84.41,43.05a.25.25,0,1,1,.25.26A.26.26,0,0,1,84.41,43.05Zm0,.44h.44v1.7h-.44Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M87.06,44.34a.93.93,0,1,1-.93-.88A.9.9,0,0,1,87.06,44.34Zm-.43,0a.49.49,0,0,0-.5-.49.49.49,0,1,0,0,1A.49.49,0,0,0,86.63,44.34Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M89,44.24v.95h-.44v-.95c0-.26-.13-.39-.37-.39a.56.56,0,0,0-.38.14v1.2h-.43v-1.7h.43v.11a.81.81,0,0,1,.46-.14C88.77,43.46,89,43.69,89,44.24Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.29,44.21a4.32,4.32,0,0,1-.34.51l.27.26-.27.24L91.71,45a1,1,0,0,1-.59.24c-.51,0-.83-.24-.83-.64a.67.67,0,0,1,.46-.6.59.59,0,0,1,.43-1,.58.58,0,0,1,.63.55.68.68,0,0,1-.48.6l.38.37a2.13,2.13,0,0,0,.26-.37Zm-.81.52L91,44.25c-.18.07-.27.18-.27.31s.15.31.42.31A.52.52,0,0,0,91.48,44.73Zm-.56-1.16c0,.16.14.26.2.32s.32-.15.32-.32-.08-.3-.26-.3A.28.28,0,0,0,90.92,43.57Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.21,43h.49l-1,2.21h-.2l-1-2.21h.48l.65,1.44Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M95.89,43.05a.25.25,0,1,1,.25.26A.26.26,0,0,1,95.89,43.05Zm0,.44h.43v1.7h-.43Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.84,44.73a1.37,1.37,0,0,0,.58.14c.2,0,.28-.08.28-.16s-.1-.14-.36-.2-.63-.2-.63-.53.25-.52.65-.52a1.61,1.61,0,0,1,.66.14l-.14.32a1.44,1.44,0,0,0-.53-.11c-.17,0-.25.06-.25.15s.1.14.37.19.63.22.63.53-.25.54-.69.54a1.5,1.5,0,0,1-.73-.16Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.11,43.49v1.7h-.43v-.12a.92.92,0,0,1-.5.15.88.88,0,0,1,0-1.76,1,1,0,0,1,.5.14v-.11Zm-.43.51a.67.67,0,0,0-.42-.15.49.49,0,0,0-.51.49.5.5,0,0,0,.51.49.67.67,0,0,0,.42-.15Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.22,44.54c0,.43-.34.68-.85.68a1.66,1.66,0,0,1-.92-.21l.16-.35a1.59,1.59,0,0,0,.77.17c.24,0,.39-.09.39-.25s-.15-.21-.47-.29-.83-.23-.83-.67.31-.66.82-.66a2.06,2.06,0,0,1,.85.18l-.19.35a1.91,1.91,0,0,0-.67-.14c-.23,0-.35.1-.35.23s.16.23.49.3C102.9,44,103.22,44.14,103.22,44.54Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.9,44.47a.48.48,0,0,0,.49.38.6.6,0,0,0,.44-.21l.27.23a.92.92,0,0,1-.76.35.88.88,0,1,1,0-1.76.81.81,0,0,1,.82.91v.1Zm0-.28h.85a.38.38,0,0,0-.41-.38A.45.45,0,0,0,103.9,44.19Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M105.91,43.73a.65.65,0,0,1,.54-.27l.11,0V44l-.21,0a.41.41,0,0,0-.44.44v.82h-.43v-1.7h.43Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.54,43.49l-.82,1.7h-.21l-.81-1.7h.45l.47,1,.46-1Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.76,43.05a.25.25,0,1,1,.25.26A.26.26,0,0,1,108.76,43.05Zm0,.44h.43v1.7h-.43Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.14,44.88a.8.8,0,0,1-.65.34.88.88,0,1,1,0-1.76.81.81,0,0,1,.66.34l-.28.26a.47.47,0,0,0-.38-.21.49.49,0,1,0,0,1,.49.49,0,0,0,.38-.21Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.75,44.47a.48.48,0,0,0,.49.38.57.57,0,0,0,.44-.21l.28.23a1,1,0,0,1-.77.35.88.88,0,0,1,0-1.76.82.82,0,0,1,.83.91s0,.07,0,.1Zm0-.28h.84a.37.37,0,0,0-.41-.38A.44.44,0,0,0,111.76,44.19Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.4,44.73a1.37,1.37,0,0,0,.58.14c.2,0,.28-.08.28-.16s-.1-.14-.36-.2-.63-.2-.63-.53.25-.52.65-.52a1.61,1.61,0,0,1,.66.14l-.14.32a1.44,1.44,0,0,0-.53-.11c-.17,0-.25.06-.25.15s.1.14.37.19.63.22.63.53-.25.54-.69.54a1.5,1.5,0,0,1-.73-.16Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "300.77 425.32 257.82 353.74 214.87 425.32 300.77 425.32"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 138.99,
    x2: 300.77,
    y2: 138.99
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 425.32,
    x2: 300.77,
    y2: 425.32
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 396.69,
    x2: 300.77,
    y2: 396.69
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 368.06,
    x2: 300.77,
    y2: 368.06
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 339.42,
    x2: 300.77,
    y2: 339.42
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 310.79,
    x2: 300.77,
    y2: 310.79
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 282.16,
    x2: 300.77,
    y2: 282.16
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 253.53,
    x2: 300.77,
    y2: 253.53
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 224.89,
    x2: 300.77,
    y2: 224.89
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 196.26,
    x2: 300.77,
    y2: 196.26
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 167.63,
    x2: 300.77,
    y2: 167.63
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 411.01,
    x2: 300.77,
    y2: 411.01
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 382.37,
    x2: 300.77,
    y2: 382.37
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 353.74,
    x2: 300.77,
    y2: 353.74
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 325.11,
    x2: 300.77,
    y2: 325.11
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 296.47,
    x2: 300.77,
    y2: 296.47
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 267.84,
    x2: 300.77,
    y2: 267.84
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 239.21,
    x2: 300.77,
    y2: 239.21
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 210.58,
    x2: 300.77,
    y2: 210.58
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 181.94,
    x2: 300.77,
    y2: 181.94
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 153.31,
    x2: 300.77,
    y2: 153.31
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 138.99,
    x2: 300.77,
    y2: 138.99
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 0.13,
    x2: 0.13,
    y2: 425.32
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 286.45,
    y1: 0.13,
    x2: 286.45,
    y2: 425.32
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 28.76,
    y1: 0.13,
    x2: 28.76,
    y2: 425.32
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 57.39,
    y1: 0.13,
    x2: 57.39,
    y2: 425.32
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 86.02,
    y1: 0.13,
    x2: 86.02,
    y2: 425.32
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 114.66,
    y1: 0.13,
    x2: 114.66,
    y2: 425.32
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 143.29,
    y1: 0.13,
    x2: 143.29,
    y2: 425.32
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 171.92,
    y1: 0.13,
    x2: 171.92,
    y2: 425.32
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 200.55,
    y1: 0.13,
    x2: 200.55,
    y2: 425.32
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 229.19,
    y1: 0.13,
    x2: 229.19,
    y2: 425.32
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 257.82,
    y1: 0.13,
    x2: 257.82,
    y2: 425.32
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 14.44,
    y1: 0.13,
    x2: 14.44,
    y2: 425.32
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 43.07,
    y1: 0.13,
    x2: 43.07,
    y2: 425.32
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 71.71,
    y1: 0.13,
    x2: 71.71,
    y2: 425.32
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 100.34,
    y1: 0.13,
    x2: 100.34,
    y2: 425.32
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 128.97,
    y1: 0.13,
    x2: 128.97,
    y2: 425.32
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 157.61,
    y1: 0.13,
    x2: 157.61,
    y2: 425.32
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 186.24,
    y1: 0.13,
    x2: 186.24,
    y2: 425.32
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 214.87,
    y1: 0.13,
    x2: 214.87,
    y2: 425.32
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 243.5,
    y1: 0.13,
    x2: 243.5,
    y2: 425.32
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 272.14,
    y1: 0.13,
    x2: 272.14,
    y2: 425.32
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 300.77,
    y1: 0.13,
    x2: 300.77,
    y2: 425.32
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 110.36,
    x2: 300.77,
    y2: 110.36
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 81.73,
    x2: 300.77,
    y2: 81.73
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 53.1,
    x2: 300.77,
    y2: 53.1
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 24.46,
    x2: 300.77,
    y2: 24.46
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 124.68,
    x2: 300.77,
    y2: 124.68
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 96.04,
    x2: 300.77,
    y2: 96.04
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 67.41,
    x2: 300.77,
    y2: 67.41
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 38.78,
    x2: 300.77,
    y2: 38.78
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 0.13,
    y1: 10.15,
    x2: 300.77,
    y2: 10.15
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(28.76 387.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11"
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.83,
    y: 0
  }, "angaroo Education Foundation Education &amp; Visa Services"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 5.45
  }, "Suite 1001, "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 22.13,
    y: 5.45
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 24.28,
    y: 5.45
  }, "evel 1"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 35.36,
    y: 5.45
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 38,
    y: 5.45
  }, ", 307 Pitt "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 56.6,
    y: 5.45
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 59.19,
    y: 5.45
  }, "treet"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 0,
    y: 10.91
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 2.64,
    y: 10.91
  }, "ydney NSW 200"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 35.26,
    y: 10.91
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 37.9,
    y: 10.91
  }, ", "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 40.12,
    y: 10.91
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 43.06,
    y: 10.91
  }, "ustralia"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 0,
    y: 16.36
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.36,
    y: 16.36
  }, ": +61-2-80605365"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21.82
  }, "ww"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 6.67,
    y: 21.82
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.81,
    y: 21.82
  }, ".kangarooedu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 37.5,
    y: 21.82
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    x: 38.51,
    y: 21.82
  }, "com")))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 0.13,
    y: 0.13,
    width: 300.64,
    height: 425.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial3);
export default __webpack_public_path__ + "static/media/guideMaterial3.44373a93a27eaa5324818822fb17b11d.svg";
export { ForwardRef as ReactComponent };